// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'page-details-section-qa',
    standalone: false,
    template: `
        <div class="row max-height">
            <div class="col-16 col-md-12 col-lg-10 pr-0 page-details-sitemenu border-right max-height scroll">
                <ul class="sidebar-nav">
                    <li *ngIf="showBrokenLinks">
                        <button data-test="broken-links-tab"
                                [class.active]="active === 'brokenlinks'"
                                [attr.aria-label]="'Broken Links' | translate"
                                (click)="active = 'brokenlinks'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-broken-links'}">
                            <span class="fas fa-fw fa-unlink text-danger mr-2" aria-hidden="true"></span>
                            <span class="full-width" translate>Broken Links</span>
                            <span *ngIf="page.dead_links_count !== 0" class="label label-danger">{{ page.dead_links_count }}</span>
                            <span *ngIf="page.dead_links_count === 0" class="fas fa-check text-success"></span>
                        </button>
                    </li>
                    <li *ngIf="showBrokenLinks">
                        <button data-test="broken-images-tab"
                                [class.active]="active === 'brokenimages'"
                                [attr.aria-label]="'Broken Images' | translate"
                                (click)="active = 'brokenimages'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-broken-images'}">
                            <span class="fas fa-fw fa-file-image text-danger mr-2" aria-hidden="true"></span>
                            <span class="full-width" translate>Broken Images</span>
                            <span *ngIf="page.dead_images_count !== 0" class="label label-danger">{{ page.dead_images_count }}</span>
                            <span *ngIf="page.dead_images_count === 0" class="fas fa-check text-success"></span>
                        </button>
                    </li>
                    <li *ngIf="showSpell">
                        <!-- TODO: Update so we update the counts without refresh: https://zube.io/monsido/monsido/c/26065 -->
                        <button data-test="misspellings-tab"
                                [class.active]="active === 'misspellings'"
                                [attr.aria-label]="'Misspellings' | translate"
                                (click)="active = 'misspellings'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-misspelling'}">
                            <span class="fas fa-fw fa-language text-confirmed-misspelling-color mr-2" aria-hidden="true"></span>
                            <span class="full-width" translate>Misspellings</span>
                            <span *ngIf="page.spelling_errors_confirmed_count !== 0"
                                  class="label label-danger">{{ page.spelling_errors_confirmed_count }}</span>
                            <span *ngIf="page.spelling_errors_confirmed_count === 0" class="fas fa-check text-success"></span>
                        </button>
                    </li>
                    <li *ngIf="showSpell">
                        <button data-test="potential-misspellings-tab"
                                [class.active]="active === 'potential'"
                                [attr.aria-label]="'Potential Misspellings' | translate"
                                (click)="active = 'potential'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-potential-misspelling'}">
                            <span class="fas fa-fw fa-language text-potential-misspelling-color mr-2"></span>
                            <span class="full-width" translate>Potential Misspellings</span>
                            <span *ngIf="page.spelling_errors_potential_count !== 0" class="label label-info">{{ page.spelling_errors_potential_count }}</span>
                            <span *ngIf="page.spelling_errors_potential_count === 0" class="fas fa-check text-success"></span>
                        </button>
                    </li>
                    <li *ngIf="showSpell">
                        <button data-test="ignored-misspellings-tab"
                                [class.active]="active === 'spell-ignored'"
                                [attr.aria-label]="'Ignored Misspellings' | translate"
                                (click)="active = 'spell-ignored'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-ignored-misspelling'}">
                            <span class="fas fa-fw fa-language mr-2" aria-hidden="true"></span>
                            <span class="full-width" translate>Ignored Misspellings</span>
                        </button>
                    </li>
                    <li data-test="readability-tab" *ngIf="'readability' | domainActiveFeature">
                        <button [class.active]="active === 'readability'"
                                [attr.aria-label]="'Readability' | translate"
                                (click)="active = 'readability'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-readability'}">
                            <span class="fas fa-fw fa-eye mr-2" aria-hidden="true"></span>
                            <span class="full-width" translate>Readability</span>
                        </button>
                    </li>
                    <li data-test="language-match-tab" *ngIf="showLanguageMatch">
                        <button [class.active]="active === 'language-match'"
                                [attr.aria-label]="'Language Validation' | translate"
                                (click)="active = 'language-match'"
                                monEventTrigger="actionTrigger"
                                [monEventParams]="{action: 'page-details-qa-language-match'}">
                            <span class="fas fa-fw mr-2" [ngClass]="['QA', 'LANGUAGE'] | monIcons" aria-hidden="true"></span>
                            <span class="full-width" translate>Language Validation</span>
                            <span *ngIf="hasLanguageMatchIssues()" class="label label-warning">!</span>
                            <span *ngIf="!hasLanguageMatchIssues() && hasLanguageMatchData()" class="fas fa-check text-success"></span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="col-32 col-md-36 col-lg-38 max-height">
                <div class="row max-height">
                    <div class="col-48 max-height scroll bg-light-grey">
                        <page-details-section-qa-broken
                                icon="fas fa-unlink"
                                [headline]="'Broken Links' | translate"
                                [pageObj]="page"
                                [type]="'not_image'"
                                (refreshPage)="onRefreshPage()"
                                *ngIf="active === 'brokenlinks'">
                        </page-details-section-qa-broken>
                        <page-details-section-qa-broken
                                icon="fas fa-file-image"
                                [headline]="'Broken Images' | translate"
                                [type]="'image'"
                                [pageObj]="page"
                                (refreshPage)="onRefreshPage()"
                                *ngIf="active === 'brokenimages'">
                        </page-details-section-qa-broken>
                        <page-details-section-qa-spell
                                type="potential"
                                [headline]="'Potential Misspellings' | translate"
                                [pageObj]="page"
                                (refreshPage)="onRefreshPage()"
                                *ngIf="active === 'potential'">
                        </page-details-section-qa-spell>
                        <page-details-section-qa-spell
                                type="confirmed"
                                [pageObj]="page"
                                (refreshPage)="onRefreshPage()"
                                *ngIf="active === 'misspellings'">
                        </page-details-section-qa-spell>
                        <page-details-section-qa-ignored-spell
                                [activePage]="page"
                                (refreshPage)="onRefreshPage()"
                                *ngIf="active === 'spell-ignored'">
                        </page-details-section-qa-ignored-spell>
                        <page-details-section-qa-readability
                                [pageObj]="page"
                                *ngIf="('readability' | activeFeature) && active === 'readability'">
                        </page-details-section-qa-readability>
                        <page-details-section-qa-language-match
                                [pageObj]="page"
                                *ngIf="showLanguageMatch && active === 'language-match'">
                        </page-details-section-qa-language-match>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionQaComponent implements OnInit {
    @Input() page: any;
    @Input() active: any;
    @Output() refreshPage = new EventEmitter<any>();

    showBrokenLinks: any;
    showSpell: any;
    showReadability: any;
    showLanguageMatch: any;

    constructor (
        private sessionService: SessionService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.showBrokenLinks = this.activeFeatureService.isFeatureActivePure('qa_links');
        this.showSpell = this.activeFeatureService.isFeatureActivePure('qa_spellcheck');
        this.showReadability = this.activeFeatureService.isFeatureActivePure('admin_readability');
        this.showLanguageMatch = this.activeFeatureService.isFeatureActivePure('language_match');
        this.active = this.selectQaSection();
        this.page = this.page || {};
    }

    private selectQaSection (): any {
        const qaSections: any[] = [];
        if (this.showBrokenLinks) {
            qaSections.push('brokenlinks');
            qaSections.push('brokenimages');
        }
        if (this.showSpell) {
            qaSections.push('misspellings');
            qaSections.push('potential');
            qaSections.push('spell-ignored');
        }
        if (this.showReadability) {
            qaSections.push('readability');
        }
        if (this.showLanguageMatch) {
            qaSections.push('language-match');
        }

        const index = qaSections.indexOf(this.active);
        if (index === -1) {
            return qaSections[0];
        }
        return qaSections[index];
    }

    onRefreshPage (): void {
        this.refreshPage.emit({ target: 'page-details-section-qa' });
    }

    hasLanguageMatchData (): boolean {
        return this.page && this.page.language_match &&
               (this.page.language_match.declared_language ||
                (this.page.language_match.detected_languages && this.page.language_match.detected_languages.length > 0));
    }

    hasLanguageMatchIssues (): boolean {
        return this.page && this.page.language_match && this.page.language_match.tag_mismatched_language === true;
    }
}
